<div>
    <span style = "color:aliceblue" >{{seconds | time }}</span>
</div>